export default __webpack_public_path__ + "static/media/service-icon-2.78e44482.png";